import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";
import axiosInstance from "../../services/axios-instance";
import { All_USERS_URL, HOME_OFFICE_DAYS } from "../../services/endpoints";
import { AllUsersInterface } from "../../interface/allUsersInterface";

interface DataItem {
    user_id: string;
    date: string;
  }

  interface HomeOfficeData {
    [month: string]: number; // month is the key, and the value is a number
  }

const countRowsPerUserPerMonth = (data : DataItem[], year : any) => {
    const result: { [key: string]: any } = {}; 
    data.forEach(({ user_id, date }) => {
        if (date.startsWith(year)) {
            const month = date.slice(0, 7); // Extract YYYY-MM
            if (!result[user_id]) {
                result[user_id] = {};
            }
            if (!result[user_id][month]) {
                result[user_id][month] = 0;
            }
            result[user_id][month]++;
        }
    });
    return result;
};

const HomeOffice = () => {
    const [users, setUsers] = useState<AllUsersInterface[]>([]);
const [homeOfficeData, setHomeOfficeData] = useState<{ [userId: string]: HomeOfficeData }>({});
    const [year, setYear] = useState(new Date().getFullYear().toString());

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseAllUsers = await axiosInstance.get(All_USERS_URL);
                setUsers(responseAllUsers.data.data);
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchHomeOfficeStatus = async () => {
            try {
                const response = await axiosInstance.get(HOME_OFFICE_DAYS, {
                    params: { year: 2025 }
                  });
                const processedData = countRowsPerUserPerMonth(response.data, year);
                setHomeOfficeData(processedData);
            } catch (error) {
                console.error('Error fetching home office status:', error);
            }
        };
        fetchHomeOfficeStatus();
    }, [year]);

    const allMonths = Array.from(new Set(
        Object.values(homeOfficeData).flatMap(user => Object.keys(user))
    )).sort();

    const changeYear = (direction : number) => {
        setYear((prevYear) => (parseInt(prevYear) + direction).toString());
    };

    return (
        <div>
            <Button onClick={() => changeYear(-1)}>Previous Year</Button>
            <span style={{ margin: "0 16px", fontWeight: "bold" }}>{year}</span>
            <Button onClick={() => changeYear(1)}>Next Year</Button>
            <TableContainer component={Paper} style={{ marginTop: "16px" }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>User</TableCell>
                            {allMonths.map(month => (
                                <TableCell key={month}>{month}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map(user => (
                            <TableRow key={user.id}>
                                <TableCell>{user.name}</TableCell>
                                {allMonths.map(month => (
                                    <TableCell key={month}>{homeOfficeData[user.id]?.[month] || 0}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default HomeOffice;
